<template>
  <div class="addReimbursement">
    <el-scrollbar class="formBox" v-scrollbar-height>
      <el-form ref="ruleForm" :model="form" label-width="142px">
        <div class="reimbursementInfo">
          <el-page-header
            @back="$emit('toggle', { name: 'ReimbursementTab' })"
            content="报销申请"
            class="pageHead"
          />
          <div class="modelTit">报销信息</div>
          <el-row :gutter="0">
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
              <el-form-item label="申请人：" :rules="rules.notEmpty">
                <el-input
                  placeholder="请输入申请人"
                  size="medium"
                  style="width: 240px"
                  clearable
                  disabled
                  v-model="ApplyUserName"
                />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
              <el-form-item
                label="付款费用归属部门："
                prop="CostDeptId"
                :rules="rules.notEmpty"
              >
                <el-cascader
                  size="medium"
                  style="width: 240px"
                  v-model="form.CostDeptId"
                  placeholder="请选择付款费用归属部门"
                  :options="OrgStructure"
                  :props="{
                    label: 'Title',
                    value: 'ID',
                    checkStrictly: true,
                    emitPath: false
                  }"
                  :show-all-levels="false"
                  filterable
                  clearable
                />
              </el-form-item>
            </el-col>
            <template v-if="isFinance || ApplyUserName === 'Admin'">
              <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                <el-form-item
                  label="一级科目："
                  prop="FinancialEntry"
                  :rules="rules.notEmpty"
                >
                  <el-select
                    size="medium"
                    placeholder="请选择一级科目"
                    style="width: 240px"
                    clearable
                    filterable
                    @change="stairChange"
                    v-model="form.FinancialEntry"
                  >
                    <el-option
                      v-for="item in stairArr"
                      :key="item.ID"
                      :label="item.Title"
                      :value="item.Name"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                <el-form-item
                  label="二级科目："
                  prop="FinancialSubEntry"
                  :rules="rules.notEmpty"
                >
                  <el-select
                    size="medium"
                    placeholder="请选择二级科目"
                    style="width: 240px"
                    clearable
                    filterable
                    :disabled="!filterSecondary.length"
                    v-model="form.FinancialSubEntry"
                  >
                    <el-option
                      v-for="item in filterSecondary"
                      :key="item.ID"
                      :label="item.Title"
                      :value="item.Name"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </template>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
              <el-form-item
                label="收款人："
                prop="Payee"
                :rules="rules.notEmpty"
              >
                <el-input
                  placeholder="请输入收款人"
                  size="medium"
                  style="width: 240px"
                  clearable
                  v-model.trim="form.Payee"
                />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
              <el-form-item
                label="开户行："
                prop="PayeeBankName"
                :rules="rules.notEmpty"
              >
                <el-input
                  placeholder="请输入开户行"
                  size="medium"
                  style="width: 240px"
                  clearable
                  v-model.trim="form.PayeeBankName"
                />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
              <el-form-item
                label="收款账号："
                prop="PayeeBankAccount"
                :rules="rules.shroffAccount"
              >
                <el-input
                  placeholder="请输入收款账号"
                  size="medium"
                  style="width: 240px"
                  clearable
                  v-model.trim="form.PayeeBankAccount"
                />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
              <el-form-item label="报销备注：" prop="Remarks">
                <el-input
                  placeholder="请输入备注"
                  size="medium"
                  style="width: 688px"
                  clearable
                  v-model="form.Remarks"
                />
              </el-form-item>
            </el-col>
            <template v-if="isFinance || ApplyUserName === 'Admin'">
              <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                <el-form-item
                  label="是否进行审批："
                  prop="IsNeedToAudit"
                  :rules="rules.notEmpty"
                >
                  <el-radio-group v-model="form.IsNeedToAudit">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                <el-form-item
                  label="是否支出："
                  prop="IsExpenditure"
                  :rules="rules.notEmpty"
                >
                  <el-radio-group v-model="form.IsExpenditure">
                    <el-radio :label="true">是</el-radio>
                    <el-radio :label="false">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </template>
          </el-row>
        </div>
        <div class="expense">
          <el-button
            icon="el-icon-plus"
            size="small"
            round
            plain
            class="addExpense"
            @click="addExpense"
            >新增费用</el-button
          >
          <div
            class="expenseItem"
            :class="{ borderTop: i > 0 }"
            v-for="(item, i) in form.Fees"
            :key="i"
          >
            <div class="modelTit">
              费用信息
              <span class="serialNum">{{ i + 1 }}</span>
              <span class="clear" v-if="i > 0" @click="removeExpenseInfo(i)"
                ><i class="el-icon-remove"></i
              ></span>
            </div>
            <el-row :gutter="0">
              <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                <el-form-item
                  label="费用类型："
                  :prop="`Fees[${i}].FeeCategory`"
                  :rules="rules.notEmpty"
                >
                  <el-select
                    size="medium"
                    placeholder="请选择费用类型"
                    style="width: 240px"
                    clearable
                    filterable
                    v-model="item.FeeCategory"
                  >
                    <el-option
                      v-for="item in secondaryArr"
                      :key="item.ID"
                      :label="item.Title"
                      :value="item.Name"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                <el-form-item
                  label="费用事由："
                  :prop="`Fees[${i}].FeeMemo`"
                  :rules="rules.notEmpty"
                >
                  <el-input
                    placeholder="请输入费用事由"
                    size="medium"
                    style="width: 240px"
                    clearable
                    v-model.trim="item.FeeMemo"
                  />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                <el-form-item
                  label="费用金额："
                  :prop="`Fees[${i}].FeeAmount`"
                  :rules="rules.amount"
                >
                  <el-input
                    placeholder="请输入费用金额"
                    size="medium"
                    style="width: 270px"
                    clearable
                    v-model="item.FeeAmount"
                    @blur="computeTotal"
                  >
                    <template slot="append"> 元 </template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
                <el-form-item
                  label="发生时间："
                  :prop="`Fees[${i}].OccurDate`"
                  :rules="rules.notEmpty"
                >
                  <el-date-picker
                    type="date"
                    size="medium"
                    value-format="yyyy-MM-dd"
                    placeholder="请选择发生时间"
                    style="width: 240px"
                    clearable
                    v-model="item.OccurDate"
                  />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                <el-form-item label="备注：" :prop="`Fees[${i}].Remarks`">
                  <el-input
                    placeholder="请输入备注信息"
                    size="medium"
                    style="width: 688px"
                    clearable
                    v-model="item.Remarks"
                  />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="6">
                <el-form-item
                  label="发票类型："
                  :prop="`Fees[${i}].InvoiceType`"
                >
                  <el-radio-group v-model="item.InvoiceType">
                    <el-radio label="电票">电子发票</el-radio>
                    <el-radio label="纸票">纸质发票</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <!-- <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6"> -->
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-form-item
                  label="发票："
                  :prop="`Fees[${i}].InvoiceAttachmentIds`"
                  :rules="[
                    {
                      required: item.InvoiceType === '电票',
                      message: '不能为空！',
                      trigger: ['blur', 'change']
                    }
                  ]"
                >
                  <div style="display: flex">
                    <div
                      v-if="item.InvoiceAttachmentIds.length > 0"
                      style="display: flex; flex-wrap: wrap; margin-right: 20px"
                    >
                      <div
                        v-for="(
                          itemFile, indexFile
                        ) in item.InvoiceAttachmentIds"
                        :key="indexFile"
                        style="margin: 0 20px 20px 0"
                      >
                        <upload-file-btn
                          accept=".png,.jpg,.jpeg,.pdf"
                          :existing="item.InvoiceAttachmentIds && itemFile"
                          :deletable="true"
                          @setFile="
                            file => {
                              getFile(file, item)
                            }
                          "
                          @remove="removeFile(item, indexFile)"
                        />
                      </div>
                    </div>
                    <upload-file-btn
                      accept=".png,.jpg,.jpeg,.pdf"
                      :existing="item.InvoiceAttachmentIds"
                      :deletable="true"
                      @setFile="
                        file => {
                          getFile(file, item)
                        }
                      "
                      @remove="removeFile(item, indexFile)"
                    />
                  </div>
                  <!-- <upload-file-btn
                    accept=".png,.jpg,.jpeg,.pdf"
                    :existing="
                      item.InvoiceAttachmentIds &&
                      JSON.parse(item.InvoiceAttachmentIds)[0]
                    "
                    :deletable="true"
                    @setFile="
                      file => {
                        getFile(file, item)
                      }
                    "
                    @remove="removeFile(item)"
                  /> -->
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="submitBox">
          <div class="left">
            <p class="total">
              报销总金额<i> ¥ </i
              ><span>{{ $common.moneyFormat(form.TotalAmount) }}</span>
            </p>
            <p class="prompt">最终费用以财务核实为准</p>
          </div>
          <div class="right">
            <div
              class="submitBtn"
              v-loading="submitLoad"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(68, 114, 177)"
              @click="submit"
            >
              提交报销单
            </div>
          </div>
        </div>
      </el-form>
    </el-scrollbar>

    <el-dialog
      title="选择下一流程审批人"
      :close-on-click-modal="false"
      :visible.sync="nextNodeShow"
      center
      width="520px"
    >
      <div class="ruleForm" v-if="nextNode">
        <el-form :model="{ nextNodeId }" label-width="200px">
          <el-form-item label="下一流程审批人：">
            <el-radio-group class="radioGroup" v-model="nextNodeId">
              <el-radio
                v-for="item in nextNode.ManualDecisionNodes"
                :key="item.ID"
                :label="item.ID"
                >{{ item.FullName }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div class="submitBtn">
          <el-button
            size="medium"
            class="cancelWireless"
            @click="nextNodeShow = false"
            >取 消</el-button
          >
          <el-button
            size="medium"
            type="primary"
            @click="confirm"
            :loading="nextNodeDialogLoad"
            >确 定</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { basic } from '../../http/api'
import { fetchSysDicList } from '../../http/dictionary'
const validateAccountNumber = (rule, value, callback) => {
  if (!/^(\d{9,20})$/.test(value)) {
    callback(new Error('收款账号格式不合法'))
  } else {
    callback()
  }
}
const validateAmount = (rule, value, callback) => {
  let reg =
    /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/
  if (!reg.test(value)) {
    callback(new Error('请输入正确格式的金额，最多保留两位小数！'))
  } else {
    callback()
  }
}
export default {
  name: 'AddReimbursement',
  props: ['isFinance'],
  data () {
    return {
      ApplyUserName: JSON.parse(localStorage.getItem('userInfo') || '{}')
        .UserName,
      stairArr: [],
      secondaryArr: [],
      filterSecondary: [],
      OrgStructure: [],
      OrgStructureQuery: [],
      nextNode: null,
      submitLoad: false,
      nextNodeShow: false,
      nextNodeDialogLoad: false,
      nextNodeId: null,
      form: {
        CostDeptName: '',
        CostDeptId: null,
        FinancialEntry: '',
        FinancialSubEntry: '',
        Payee: '',
        PayeeBankName: '',
        PayeeBankAccount: '',
        IsNeedToAudit: true,
        IsExpenditure: false,
        Remarks: '',
        TotalAmount: 0,
        Fees: [
          {
            FeeCategory: '',
            FeeMemo: '',
            FeeAmount: null,
            OccurDate: '',
            Remarks: '',
            InvoiceType: null,
            // InvoiceAttachmentIds: ''
            InvoiceAttachmentIds: []
          }
        ]
      },
      rules: {
        notEmpty: [
          { required: true, message: '不能为空！', trigger: ['blur', 'change'] }
        ],
        shroffAccount: [
          {
            required: true,
            message: '不能为空！',
            trigger: ['blur', 'change']
          },
          { validator: validateAccountNumber, trigger: ['blur', 'change'] }
        ],
        amount: [
          {
            required: true,
            message: '不能为空！',
            trigger: ['blur', 'change']
          },
          { validator: validateAmount, trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    confirm () {
      if (
        this.nextNode &&
        this.nextNode.IsManualDecisionNode &&
        !this.nextNodeId
      ) {
        this.$message.warning('请选择下一流程审批人')
        return
      }
      this.nextNodeDialogLoad = true
      let find = this.OrgStructureQuery.find(
        item => item.ID === this.form.CostDeptId
      )
      this.form.CostDeptName = (find && find.Title) || ''
      // 深浅拷贝数据，省的修改数据源导致多个发票展示有问题
      let objForm = JSON.parse(JSON.stringify(this.form))
      // 发票数据格式转字符串给后端
      objForm.Fees.forEach(item => {
        item.InvoiceAttachmentIds = JSON.stringify(item.InvoiceAttachmentIds)
      })
      let {
        FinancialEntry,
        FinancialSubEntry,
        IsNeedToAudit,
        IsExpenditure,
        ...objRest
        // } = this.form
      } = objForm
      basic('ReimbursementWorkflow', 'Submit', {
        workflowEntity:
          this.isFinance || this.ApplyUserName === 'Admin'
            ? // ? this.form
              objForm
            : objRest,
        deviceType: 0,
        manualDecisionNodeChildId: this.nextNodeId,
        manualDecisionNodeParentId:
          this.nextNode && this.nextNode.IsManualDecisionNode
            ? this.nextNode.ID
            : null // 需要决策时才传ID
      })
        .then(res => {
          this.$message({
            type: res.Code === 1 ? 'success' : 'error',
            message: res.Message,
            customClass: 'zindexMax'
          })
          if (res.Code === 1) {
            this.nextNodeShow = false
            this.$confirm(
              `<i class='el-icon-success' style='color:#41b035'></i>流程提交成功！是否继续提交?`,
              '提示',
              {
                confirmButtonText: '继续提交',
                cancelButtonText: '退出',
                center: true,
                showClose: false,
                closeOnPressEscape: false,
                dangerouslyUseHTMLString: true,
                closeOnClickModal: false,
                cancelButtonClass: 'cancelWireless'
              }
            )
              .then(() => {
                // 重置数据
                this.form = this.$options.data.call(this).form
                this.nextNodeId = this.$options.data.call(this).nextNodeId
              })
              .catch(() => {
                this.$emit('toggle', { name: 'ReimbursementTab' })
              })
          }
        })
        .finally(_ => {
          this.nextNodeDialogLoad = false
        })
    },
    submit () {
      if (this.submitLoad) return
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitLoad = true
          let find = this.OrgStructureQuery.find(
            item => item.ID === this.form.CostDeptId
          )
          this.form.CostDeptName = (find && find.Title) || ''
          // 深浅拷贝数据，省的修改数据源导致多个发票展示有问题
          let objForm = JSON.parse(JSON.stringify(this.form))
          // 发票数据格式转字符串给后端
          objForm.Fees.forEach(item => {
            item.InvoiceAttachmentIds = JSON.stringify(
              item.InvoiceAttachmentIds
            )
          })
          let {
            FinancialEntry,
            FinancialSubEntry,
            IsNeedToAudit,
            IsExpenditure,
            ...objRest
            // } = this.form
          } = objForm
          // console.log('this.form', objForm)
          basic('ReimbursementWorkflow', 'FindNextNode', {
            type: 0,
            workflow:
              this.isFinance || this.ApplyUserName === 'Admin'
                ? // ? this.form
                  objForm
                : objRest
          })
            .then(next => {
              this.nextNodeShow = next.IsManualDecisionNode
              this.nextNode = next
              if (!next.IsManualDecisionNode) this.confirm() // 如果不需要决策直接提交
            })
            .finally(_ => {
              this.submitLoad = false
            })
        }
      })
    },
    computeTotal () {
      let total = 0
      this.form.Fees.forEach(item => {
        const isNum = isNaN(item.FeeAmount)
        if (!isNum) total += Number(item.FeeAmount)
      })
      this.form.TotalAmount = Number(total.toFixed(2))
    },
    stairChange (val) {
      this.form.FinancialSubEntry = ''
      if (val) {
        let find = this.stairArr.find(item => item.Name === val)
        let arr = this.secondaryArr.filter(item => item.ParentID === find.ID)
        this.filterSecondary = arr
      } else {
        this.filterSecondary = []
      }
    },
    init () {
      basic('OrgStructure', 'Query', {
        order: 'order asc',
        Select: 'ID,Order,OrgType,Title,ParentID,DepartmentType',
        where: '1=1 and OrgType < 6'
      }).then(res => {
        this.OrgStructureQuery = res
        this.OrgStructure = this.$common.listToTree(res)
      })
      this.stairArr = this.$ReimburseSubject.filter(item => !item.ParentID)
      this.secondaryArr = this.$ReimburseSubject.filter(item => !!item.ParentID)
    },
    // 选择文件
    getFile (file, item) {
      // item.InvoiceAttachmentIds = JSON.stringify([file.FileId])
      item.InvoiceAttachmentIds.push(file.FileId)
    },
    // 移除文件
    removeFile (item, indexFile) {
      // item.InvoiceAttachmentIds = ''
      // 数组将当前下标的下标的项删除
      item.InvoiceAttachmentIds.splice(indexFile, 1)
      console.log('删除', item, indexFile)
      console.log('item.InvoiceAttachmentIds', item.InvoiceAttachmentIds)
    },
    removeExpenseInfo (i) {
      this.form.Fees.splice(i, 1)
    },
    addExpense () {
      this.form.Fees.push({
        FeeCategory: '',
        FeeMemo: '',
        FeeAmount: '',
        OccurDate: '',
        Remarks: '',
        InvoiceType: null,
        // InvoiceAttachmentIds: ''
        InvoiceAttachmentIds: []
      })
    }
  }
}
</script>
<style scoped lang="less">
.addReimbursement {
  :deep(.el-form--inline .el-form-item) {
    margin-right: 0;
  }
}
.reimbursementInfo {
  background-color: #fff;
  padding: 0 16px;
  border-radius: 0px 8px 8px 8px;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.04);
}
.pageHead {
  padding: 16px 0;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  :deep(.el-page-header__title) {
    font-size: 16px;
  }
}
.modelTit {
  font-size: 16px;
  font-weight: bold;
  color: #494f69;
  padding-left: 12px;
  margin-left: 8px;
  margin-bottom: 16px;
  position: relative;
  display: flex;
  align-items: center;
  &::before {
    content: '';
    width: 4px;
    height: 18px;
    background: #154f9d;
    border-radius: 4px;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  .serialNum {
    display: inline-block;
    width: 16px;
    height: 16px;
    text-align: center;
    line-height: 16px;
    font-size: 12px;
    border-radius: 50%;
    border: 1px solid #ccc;
  }
  .clear {
    display: flex;
    align-items: center;
    font-size: 20px;
    color: #ff4141;
    margin-left: 12px;
    cursor: pointer;
  }
}
.expense {
  margin-top: 12px;
  background-color: #fff;
  padding: 0 16px 16px 16px;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.04);
  border-radius: 8px;
  position: relative;
  .addExpense {
    position: absolute;
    right: 24px;
    top: 16px;
    z-index: 9;
    border-color: #154f9d !important;
    color: #154f9d !important;
    &:hover {
      color: #fff !important;
      background: #154f9d !important;
    }
  }
  .expenseItem {
    padding-top: 16px;
  }
  .borderTop {
    border-top: 1px solid #f4f8fb;
  }
}
.submitBox {
  margin-top: 12px;
  padding: 32px 100px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.04);
  display: flex;
  justify-content: space-between;
  align-items: center;
  .total {
    font-size: 18px;
    font-weight: 400;
    color: #494f69;
    i {
      font-style: normal;
      color: #ff4141;
    }
    span {
      font-size: 30px;
      font-weight: bold;
      color: #ff4141;
    }
  }
  .prompt {
    color: #999999;
    font-size: 14px;
  }
  .submitBtn {
    width: 200px;
    height: 58px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    background-color: #154f9d;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
    user-select: none;
    &:hover {
      background-color: #4472b1;
    }
    :deep(.el-loading-mask) {
      border-radius: 4px;
    }
    :deep(.el-loading-spinner) {
      top: 66% !important;
      display: flex;
      justify-content: center;
      align-items: center;
      i {
        color: #ffffff;
      }
      .el-loading-text {
        margin-left: 4px;
        color: #ffffff;
      }
    }
  }
}
.ruleForm {
  padding: 16px 0 32px 0;
  .radioGroup {
    width: 22px;
    :deep(.el-radio__label) {
      padding-left: 8px;
    }
    :deep(.el-radio) {
      height: 40px;
      line-height: 40px;
      margin-right: 24px;
    }
  }
  .submitBtn {
    display: flex;
    justify-content: center;
    :deep(.el-button) {
      width: 92px;
    }
    :deep(.el-button + .el-button) {
      margin-left: 16px;
    }
  }
}
</style>
